export default "__VITE_ASSET__Cvva1zSr__"